import React from 'react'
import type { SvgIconProps } from './index.type'

const SvgIcon: React.FC<SvgIconProps> = ({ src, color = 'currentColor', size = 20, className = '', style, ...rest }) => {
  const sizeValue = typeof size === 'number' ? `${size}px` : size

  return (
    <div
      className={className}
      style={{
        display: 'inline-block',
        width: sizeValue,
        height: sizeValue,
        backgroundColor: color,
        maskImage: `url(${src})`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: `url(${src})`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        ...style,
      }}
      {...rest}
    />
  )
}

export default SvgIcon

